import * as actions from "./consts";

export const setInvalidNodes = (invalidNodes, versionUuid, flowUuid) => ({
  type: actions.SET_INVALID_NODES,
  invalidNodes,
  versionUuid,
  flowUuid,
});
